import styled, { keyframes } from "styled-components";

export const StyledMenu = styled.section`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: ${(props) => (props.menuToggle ? "flex" : "none")};
    justify-content: center;
    align-items: center;
    z-index: 15;
    overflow: hidden;
    background-color: rgb(88, 88, 88, 0.8);
    .onset {
    }
  `,
  showMenu = keyframes`
from {
  margin-right: -10rem;
}
to {
  margin-right: 0;
}
`,
  showAside = keyframes`
from {
  background-color: rgb(234, 234, 234, 0);
}
to {
  background-color: rgb(234, 234, 234, 0.7);
}
`,
  MenuAside = styled.aside`
    display: flex;
    flex-direction: column;
    width: 20rem;
    margin-top:10rem;
    height: 100%;
    padding: 1rem 0rem;
    background-color: #ffffff;
    animation: ${showMenu} 0.25s ease-in 0s 1;
  `,
  FadedAside = styled.aside`
    width: 100%;
    height: 100%;
    background-color: rgb(234, 234, 234, 0.7);
    animation: ${showAside} 0.25s ease-in 0s 1;
    
  `,
  Title = styled.h1`
    width: 100%;
    text-align: center;
    padding: 0.3rem;
    color: #083f8;
    text-decoration: none;
    white-space: nowrap;
    margin-top: 2rem;
  `,
  ButtonBox = styled.span`
    display: flex;
    width: calc(100% - 2rem);
    justify-content: flex-end;
    align-items: center;
    padding: 1rem;
    cursor: pointer;
    color: #083f88;
    transition: 0.4s;
    margin-left: 0.5rem;
    &:hover {
      color: ${({ color }) => (color === "blue" ? "#083f88" : "#00aae4")};
    }
  `,
  LinkButton = styled.a`
    color: #083f88;
    text-decoration: none;
  `,
  Close = styled.img`
    height: 100%;
  `,
  CloseBox = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: 5vw;
    width: 5vw;
    padding: 1vw;
    margin: 1vw;
    background: rgb(88, 88, 88, 0.3);
    transition: 0.4s;
    &:hover {
      background: rgb(88, 88, 88);
    }
  `;
